// extracted by mini-css-extract-plugin
export var cartIcon = "_mw-0";
export var cartIconContainer = "_mw-1";